import React, { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { useSelector } from 'store';
import RFPResponseWithRFP from 'types/api/RFPResponseWithRFP';
import SelectInput from 'components/forms/raw/SelectInput';
import { formatDate } from 'hooks/useFormattedDate';

import useSortedData from './hooks/useSortedData';

import './ProjectList.scss';

export interface ProjectListProps {}

const ProjectList: FC<ProjectListProps> = () => {
  const data = useSelector((state) => state.rfpReviewerList.data);
  const navigate = useNavigate();

  const { t } = useTranslation();

  const { sortValue, onSortChange, sortOptions, sortedData } = useSortedData(data);

  const handleNavigateToProject = (entry: RFPResponseWithRFP) => {
    navigate(`/rfp/${entry.traro_rfp.id}/rfp-response/${entry.id}`);
  };

  return (
    <div className="enkrateia-project-list">
      <div className="sort-container">
        <SelectInput
          inline
          variant="outlined"
          label="Sort by"
          value={sortValue}
          onChange={onSortChange}
          options={sortOptions}
        />
      </div>
      <table>
        <thead>
          <tr>
            <th className="left">{t('pages.dashboard.table.rfpName')}</th>
            <th>{t('pages.dashboard.table.closeDate')}</th>
            <th className="left">{t('pages.dashboard.table.status')}</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {sortedData.map((entry) => (
            <tr key={entry.id} onClick={() => handleNavigateToProject(entry)}>
              <td>{entry.project_name}</td>
              <td className="center">{formatDate(entry.traro_rfp.response_close_date)}</td>
              <td className={`status ${entry.rfp_response_status}`}>
                <div>
                  <div className="dot"></div>
                  {entry.rfp_response_status}
                </div>
              </td>
              <td width={10}>
                <svg width="8" height="15" viewBox="0 0 8 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M7.5849 8.13538C7.94045 7.7366 7.94045 7.09004 7.5849 6.69126L6.7027 5.70179C6.6728 5.66411 6.64175 5.62718 6.60954 5.59105L1.96034 0.376564C1.51251 -0.12571 0.786448 -0.12571 0.338625 0.376562C-0.109199 0.878836 -0.109198 1.69318 0.338626 2.19545L4.98805 7.41019L0.336196 12.6276C-0.111627 13.1299 -0.111628 13.9443 0.336196 14.4465C0.784019 14.9488 1.51009 14.9488 1.95791 14.4465L7.5849 8.13538Z"
                    fill="#014F71"
                  />
                </svg>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default ProjectList;
